import script from "./CollegePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CollegePage.vue?vue&type=script&lang=ts&setup=true"

import "./CollegePage.vue?vue&type=style&index=0&id=5fa2607d&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fa2607d"]])

export default __exports__